<template>
  <div
    v-if="hasBanner"
    v-on-display="{ sectionInfo, context: this }"
    class="multi multi-band-banner"
    :style="`background-color:${backgroundColor}`"
  >
    <a href="#" :style="bgImage" @click.prevent="goDetail">{{ bannerTitle }}</a>
  </div>
</template>
<script>
  import { ref, computed } from 'vue'
  import { getEventsFromEventList } from '@/common/utils/get-event-from-event-list'
  import { bannerLink } from '@/common/utils/common'
  import { convertBand } from '@/common/converter/convert-band'
  import { onDisplay } from '@/common/resources/directives'
  import { EventBus } from '@/common/utils/event-bus'
  import { ON_CLICK_CELL } from '@/common/resources/const'

  export default {
    name: 'SingleBannerCatalog',
    directives: {
      onDisplay,
    },
    props: {
      catalogInfo: {
        type: Object,
        default: null,
      },
      sectionInfo: {
        type: Object,
        default: null,
      },
    },
    setup(props) {
      const bannerInfo = ref(null)
      const backgroundColor = ref('')
      const hasBanner = computed(() => bannerInfo.value !== null)

      const bgImage = computed(
        () => `background-image:url(${bannerInfo.value?.thumbnail})`,
      )
      const bannerTitle = computed(
        () => `${bannerInfo.value?.title_list?.[0]?.text ?? ''} 바로가기`,
      )

      const goDetail = () => {
        const eventList = bannerInfo.value?.event_list
        const { onClick, onNavigation } = getEventsFromEventList(eventList, [
          'onClick',
          'onNavigation',
        ])

        if (onClick) {
          EventBus.$emit(ON_CLICK_CELL, onClick)
        }

        bannerLink(onNavigation?.url ?? '')
      }

      const setData = async () => {
        try {
          const bandInfo = await convertBand(props.catalogInfo)
          bannerInfo.value = bandInfo?.band?.celllist?.[0] ?? null
          backgroundColor.value = bandInfo?.note ?? null
        } catch (error) {
          console.error(error)
        }
      }

      setData()

      return {
        bannerInfo,
        backgroundColor,
        bgImage,
        bannerTitle,
        hasBanner,
        goDetail,
        setData,
      }
    },
  }
</script>
<style scoped lang="scss"></style>
